<app-gmao-spinner *ngIf="!message"></app-gmao-spinner>
<ng-container *ngIf="message">
    <div class="view-item">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
            <h5>Edition d'un message</h5>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="actif" name="actif" [checked]="message.enabled==1"
                    [(ngModel)]="message.enabled">
                <label for="actif" class="form-check-label">Activer l'envoi du message</label>
            </div>
            <div class="row justify-content-end links">
                <button routerLink="/messages-list" class="btn btn-secondary">Retour</button>
                <button class="btn btn-primary">Enregistrer</button>
                <button class="btn btn-danger" (click)="deleteMessage()">Supprimer</button>
            </div>
            <div class="row form-group">
                <label for="subject" class="col-sm-2 col-form-label">Sujet : </label>
                <div class="col-sm-6">
                    <input type="text" class="form-control form-control-sm" id="subject" [value]="message.subject"
                        name="subject" [(ngModel)]="message.subject">
                </div>
            </div>
            <div class="form-group row">
                <label for="message" class="col-sm-2 col-form-label">Message : </label>
                <div class="col-sm-6">
                    <textarea id="message" class="form-control form-control-sm" [innerHtml]="message.content"
                        [(ngModel)]="message.content" name="message">
            </textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="view-item">
        <h5>Destinataires</h5>
        <div class="row justify-content-end links">
            <!-- <a routerLink="">Ajouter une liste d'installations...</a> seems to be not used-->
            <button class="btn btn-info" (click)="addInstallation('-1')">Ajouter toutes les installations</button>
            <button class="btn btn-primary" (click)="removeInstallation('all')">Supprimer toutes les
                installations</button>
        </div>
        <div>
            <form #formInstall="ngForm" (ngSubmit)="onSubmitInstall()" novalidate >
                <mat-form-field *ngIf="installs" appearance="fill" class="select-install">
                    <mat-label translate>Ajouter une installation</mat-label>
                    <input type="text"  aria-label="Installation" matInput [formControl]="install"
                         [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let install of filteredinstalls | async" [value]="install" [innerHTML] = install.nom_installation>
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error>Veuillez renseigner une installation</mat-error>
                </mat-form-field>  
                <button class="btn btn-outline-success">+</button>
            </form>
        </div>
        <div class="table-responsive">
            <table class="table table-sm table-striped">
                <thead>
                    <th>Nom installation</th>
                    <th>Date de réception</th>
                    <th>Date de lecture</th>
                    <!-- <th></th> -->
                </thead>
                <tbody>
                    <tr *ngFor="let install of message.installations">
                        <td> <a
                                [routerLink]="['/installation',install.id_installation]">{{install.nom_installation}}</a>
                        </td>
                        <td>{{install.received_date}}</td>
                        <td>{{install.read_date}}</td>
                        <td class="material-icons pointer"
                            (click)="removeInstallation(install.id_message_installation)">close</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>